<template>
  <Card class="class-card clickable">
    <div class="card-cover-img-thumb" v-bind:style="styleBindings" v-on:click="goToClassReport"></div>
    <div class="card-cover-text">
      {{ cls.year }} {{ getShortenedString(cls.school_name, 10) }}<br>
      {{ cls.grade }}{{ $t('card_details.card_meta.grade') }} {{ getShortenedString(cls.name, 15) }}{{ $t('common.class') }} | {{ $t('common.student') }} {{ studentList.length }}{{ $t('common.modal.preview.count\n')}}
    </div>
    <div class="clickable card-cover-bottom" v-on:click="goToClassReport">
      <div class="class-card-asmt-cnt">{{ assignmentCount }}</div>
      &nbsp;{{ $t('reports.assignment_count') }}
    </div>
  </Card>
</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    name: 'class-item',

    props: [
      'cls',
    ],

    data() {
      return {
        studentList: [],
        assignmentStats: null,
      };
    },

    computed: {
      styleBindings() {
        if (this.cls) {
          return {
            'background-image': `url('${this.cls.profile_image}')`,
          };
        }

        return {};
      },

      assignmentCount() {
        if (!this.assignmentStats) {
          return 0;
        }

        return this.assignmentStats.total_count;
      },
    },

    methods: {
      ...mapActions([
        'fetchTeacherAssignmentStats',
        'fetchClassStudents',
        'syncClassStudents',
      ]),

      goToClassReport() {
        this.$router.push(`/reports/classes/${this.cls.id}`);
      },

      getShortenedString(string, maxLength) {
        if (string.length <= maxLength) {
          return string;
        }
        return `${string.substring(0, maxLength)}..`;
      },
    },

    created() {
      Promise.all([
        this.fetchTeacherAssignmentStats({ class_id: this.cls.id }),
        this.fetchClassStudents(this.cls.id),
      ])
      .then(([assignmentStats, studentList]) => {
        this.assignmentStats = assignmentStats;

        if (!studentList || studentList.length === 0) {
          return this.syncClassStudents(this.cls.id)
            .then((syncedStudentList) => {
              this.studentList = syncedStudentList;
            });
        }

        this.studentList = studentList;

        return studentList;
      });
    },
  };
</script>



// WEBPACK FOOTER //
// src/app/classes/components/ClassItem.vue